// Libraries
import { useTranslation } from 'react-i18next';

// MUI
import PasteIcon from '@mui/icons-material/Description';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import { ADefaultIconButton, AIconButtonBaseProps } from '../../common/buttons';

export interface APasteIconButtonProps extends AIconButtonBaseProps {}

export default function APasteIconButton(props: APasteIconButtonProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);
    const { tooltip, ...buttonProps } = props;
    const tooltip2 = tooltip ? tooltip : t('AnelmaGeneral:1161');

    return <ADefaultIconButton {...buttonProps} icon={<PasteIcon />} tooltip={tooltip2} />;
}
